import React from 'react';

import closeIcon from '../../assets/icons/clear.svg';

import {
  CloseDrawerButton,
  Container,
  ContainerDark,
  ContainerHeader,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from './Drawer.styles';
import { DrawerProps } from './Drawer.types';

export const Drawer: React.FC<DrawerProps> = ({
  style,
  active,
  updateActive,
  header,
  footer,
  children,
  width = '400px',
}) => {
  return (
    <>
      <ContainerDark
        data-testid={active ? 'open' : 'hidden'}
        active={active}
        onClick={() => updateActive(false)}
      />

      <Container data-testid="drawer" active={active} width={width} style={style}>
        <ContainerHeader>
          <DrawerHeader>{header}</DrawerHeader>
          {active && (
            <CloseDrawerButton data-testid="drawer-close" onClick={() => updateActive(!active)}>
              <img src={closeIcon} />
            </CloseDrawerButton>
          )}
        </ContainerHeader>

        <DrawerContent>{children}</DrawerContent>
        <DrawerFooter>{footer}</DrawerFooter>
      </Container>
    </>
  );
};
